// combatpro/panels/ShortcutsPanel.js
//
// Combat PRO - ShortcutsPanel (parity restoration).
//
// Restores the established keyboard-shortcuts reference panel that the modular
// migration dropped. The keyboard MAPPINGS themselves are the established set
// (the only proven evidence for them is the pre-modular implementation, used as
// fallback), but the panel is presented in the CURRENT modern Combat PRO drawer
// style (scoped .cp-root) rather than the old monolith styling - matching the
// existing Combat Log / Conditions drawers.
//
// Presentation only: the actual key handling lives in CombatProEngineApp (a
// single document keydown listener wired to the real context handlers, with the
// established typing guard). This component just renders the reference list and
// the close control. No state, no side effects, no em dash.

import React from 'react';

const SHORTCUTS = [
  { key: 'SPACE', desc: 'Next Combatant' },
  { key: 'R', desc: 'Roll Initiative (current monster)' },
  { key: 'L', desc: 'Toggle Combat Log' },
  { key: 'K', desc: 'Toggle Shortcuts Panel' },
  { key: 'N', desc: 'Next Round' },
  { key: 'P', desc: 'Previous Round' },
  { key: 'U', desc: 'Undo Last Action' },
  { key: 'S', desc: 'Create Snapshot' },
  { key: 'C', desc: 'Toggle Conditions' }
];

function ShortcutsPanel(props) {
  const isOpen = props.isOpen;
  return (
    <div className={isOpen ? 'shortcuts-panel open' : 'shortcuts-panel'} id="shortcutsPanel">
      <div className="shortcuts-header">
        <span>Keyboard Shortcuts</span>
        <button className="shortcuts-close" onClick={props.onClose} aria-label="Close shortcuts">✕</button>
      </div>
      <div className="shortcuts-content">
        {SHORTCUTS.map(function (s) {
          return (
            <div className="shortcut-item" key={s.key}>
              <span className="shortcut-key">{s.key}</span>
              <span className="shortcut-desc">{s.desc}</span>
            </div>
          );
        })}
        <div className="shortcut-note">Shortcuts are disabled while typing in a field.</div>
      </div>
    </div>
  );
}

export default ShortcutsPanel;
